module.exports = __webpack_public_path__ + "static/media/piquete.f0639ae8.jpg";